import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import { App } from "./App";

// Dominio principale: travel.miglioresoftware.app. Il vecchio indirizzo .com rimanda qui mantenendo percorso e parametri.
if (location.hostname === "travel.miglioresoftware.com") {
  location.replace(`https://travel.miglioresoftware.app${location.pathname}${location.search}${location.hash}`);
} else {
createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
}
